// Generated from OpenAPI by scripts/generate-forms.mjs.
export const listQueryParameters: Record<string, string[]> = {
  '/api/v1/auth/mfa': [],
  '/api/v1/notifications': ['cursor', 'limit', 'unreadOnly'],
  '/api/v1/notification-preferences': [],
  '/public/v1/file-downloads': ['token'],
  '/api/v1/me': [],
  '/api/v1/accounts': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/accounts/options': [],
  '/api/v1/accounts/{accountId}': [],
  '/api/v1/accounts/{accountId}/sessions': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/permission-groups': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/permission-groups/{groupId}': [],
  '/api/v1/service-accounts': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/workspace': [],
  '/api/v1/organizations': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/organizations/{organizationId}': [],
  '/api/v1/departments': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/departments/{departmentId}': [],
  '/api/v1/teams': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/teams/{teamId}': [],
  '/api/v1/job-functions': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/job-functions/{id}': [],
  '/api/v1/specialisations': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/specialisations/{id}': [],
  '/api/v1/seniorities': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/seniorities/{id}': [],
  '/api/v1/locations': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/locations/{id}': [],
  '/api/v1/employees': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/employees/{employeeId}': ['include'],
  '/api/v1/employees/{employeeId}/personal-details': [],
  '/api/v1/employees/{employeeId}/documents': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/employees/{employeeId}/screenings': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/employees/{employeeId}/right-to-work': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/employees/{employeeId}/compensation': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/employees/{employeeId}/payroll': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/requisitions': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/requisitions/{id}': [],
  '/api/v1/headcount-allocations': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/job-postings': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/job-postings/{id}': [],
  '/api/v1/job-postings/{id}/application-form-versions': [],
  '/api/v1/job-postings/{id}/pipeline-versions': [],
  '/api/v1/job-postings/{id}/analytics': [],
  '/api/v1/candidates': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/candidates/{id}': [],
  '/api/v1/privacy-notice-versions': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/processing-basis-policy-versions': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/candidates/{id}/processing-basis-records': [
    'cursor',
    'limit',
    'search',
    'sort',
    'filter',
  ],
  '/api/v1/candidates/{id}/consents': [],
  '/api/v1/applications': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/applications/{id}': [],
  '/api/v1/interviews/{id}': [],
  '/api/v1/offers/{id}': [],
  '/api/v1/offers/{id}/versions': [],
  '/api/v1/process-templates': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/process-templates/{id}/versions': [],
  '/api/v1/onboarding-processes': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/onboarding-processes/{id}': [],
  '/api/v1/offboarding-processes': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/offboarding-processes/{id}': [],
  '/api/v1/files/{id}': [],
  '/api/v1/bulk-operations/{id}': [],
  '/api/v1/bulk-operations/{id}/results': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/audit-events': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/retention-policies': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/api/v1/legal-holds': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/public/v1/job-postings': ['cursor', 'limit', 'search', 'sort', 'filter'],
  '/public/v1/job-postings/{publicId}': [],
  '/public/v1/job-postings/{publicId}/application-form': [],
  '/public/v1/offers/current': [],
  '/api/v1/interviews': ['cursor', 'limit', 'applicationId'],
  '/api/v1/offers': ['cursor', 'limit', 'applicationId'],
  '/api/v1/onboarding-processes/{id}/tasks': [],
  '/api/v1/offboarding-processes/{id}/tasks': [],
  '/api/v1/applications/{id}/pipeline': [],
  '/api/v1/accounts/{accountId}/access': [],
  '/api/v1/interviews/{id}/feedback-form': [],
  '/api/v1/candidates/import-options': [],
  '/api/v1/skills': ['cursor', 'limit', 'organizationId', 'status'],
  '/api/v1/skills/{id}': [],
  '/api/v1/skills/{id}/versions': ['cursor', 'limit', 'organizationId', 'status'],
  '/api/v1/skill-versions/{id}': [],
  '/api/v1/role-profiles': ['cursor', 'limit', 'organizationId', 'status'],
  '/api/v1/role-profiles/{id}': [],
  '/api/v1/role-profiles/{id}/versions': ['cursor', 'limit', 'organizationId', 'status'],
  '/api/v1/role-profile-versions/{id}': [],
  '/api/v1/employee-evaluation-templates': ['cursor', 'limit', 'organizationId', 'status'],
  '/api/v1/employee-evaluation-templates/{id}': [],
  '/api/v1/employee-evaluation-templates/{id}/versions': [
    'cursor',
    'limit',
    'organizationId',
    'status',
  ],
  '/api/v1/employee-evaluation-template-versions/{id}': [],
  '/api/v1/role-profile-versions/{id}/preview': ['seniorityId'],
  '/api/v1/specialisations/{id}/allowed-seniorities': [],
  '/api/v1/employees/{id}/role-profile-resolution': [],
  '/api/v1/employees/{id}/role-profile-assignments': [
    'cursor',
    'limit',
    'organizationId',
    'status',
  ],
  '/api/v1/performance-cycles': ['cursor', 'limit', 'organizationId', 'status'],
  '/api/v1/performance-cycles/{id}': [],
  '/api/v1/employees/{id}/work-plans': ['cursor', 'limit', 'organizationId', 'status'],
  '/api/v1/work-plans/{id}': [],
  '/api/v1/work-plans/{id}/tasks': ['cursor', 'limit', 'organizationId', 'status'],
  '/api/v1/employees/{id}/reviews': ['cursor', 'limit', 'organizationId', 'status'],
  '/api/v1/reviews/{id}': [],
  '/api/v1/reviews/{id}/submissions/{type}': [],
  '/api/v1/administrative/me': [],
  '/api/v1/administrative/sections': [],
  '/api/v1/administrative/sheets': ['sectionId'],
  '/api/v1/administrative/resources': [
    'cursor',
    'limit',
    'search',
    'sectionId',
    'sheetId',
    'projectId',
    'providerAccountId',
    'kind',
    'statusId',
    'relevanceId',
    'currency',
    'responsibleAccountId',
    'mine',
    'state',
    'from',
    'to',
    'sort',
    'direction',
  ],
  '/api/v1/administrative/resources/{id}': [],
  '/api/v1/administrative/resources/{id}/credentials': [],
  '/api/v1/administrative/resources/{id}/payments': [],
  '/api/v1/administrative/providers': [],
  '/api/v1/administrative/providers/{id}': [],
  '/api/v1/administrative/projects': [],
  '/api/v1/administrative/dictionaries': [],
  '/api/v1/administrative/roles': [],
  '/api/v1/administrative/members': [],
  '/api/v1/administrative/invites': [],
  '/api/v1/administrative/calendar': [
    'cursor',
    'limit',
    'search',
    'sectionId',
    'sheetId',
    'projectId',
    'providerAccountId',
    'kind',
    'statusId',
    'relevanceId',
    'currency',
    'responsibleAccountId',
    'mine',
    'state',
    'from',
    'to',
    'sort',
    'direction',
  ],
  '/api/v1/administrative/dashboard': [
    'cursor',
    'limit',
    'search',
    'sectionId',
    'sheetId',
    'projectId',
    'providerAccountId',
    'kind',
    'statusId',
    'relevanceId',
    'currency',
    'responsibleAccountId',
    'mine',
    'state',
    'from',
    'to',
    'sort',
    'direction',
  ],
  '/api/v1/administrative/payments': [],
  '/api/v1/administrative/trash': [
    'cursor',
    'limit',
    'search',
    'sectionId',
    'sheetId',
    'projectId',
    'providerAccountId',
    'kind',
    'statusId',
    'relevanceId',
    'currency',
    'responsibleAccountId',
    'mine',
    'state',
    'from',
    'to',
    'sort',
    'direction',
  ],
  '/api/v1/administrative/audit': [
    'cursor',
    'limit',
    'search',
    'sectionId',
    'sheetId',
    'projectId',
    'providerAccountId',
    'kind',
    'statusId',
    'relevanceId',
    'currency',
    'responsibleAccountId',
    'mine',
    'state',
    'from',
    'to',
    'sort',
    'direction',
  ],
  '/api/v1/administrative/saved-filters': [],
  '/api/v1/administrative/settings': [],
  '/api/v1/administrative/integrations/settings': [],
  '/api/v1/administrative/integrations/telegram/enrollment': [],
  '/api/v1/administrative/integrations/telegram/binding': [],
  '/api/v1/administrative/integrations/jobs/{id}': [],
  '/api/v1/administrative/integrations/export.csv': ['sheetId', 'includeCredentials'],
  '/api/v1/positions': ['cursor', 'limit', 'organizationId', 'search'],
  '/api/v1/positions/{positionId}': [],
  '/api/v1/employees/{employeeId}/history': ['cursor', 'limit'],
  '/api/v1/search': ['q', 'limit', 'cursor'],
};
